<template>
    <v-row>

        <v-col cols="12" class="py-0 my-0">
            <span>Комментарии</span>
        </v-col>
        <v-col cols="10" md6 align-self="center" class="pt-0">
            <v-textarea
                    label="Напишите комментарий"
                    hide-details
                    rows="1"
                    auto-grow
                    v-model="cardCommentModel.description"
            />
        </v-col>
        <v-col cols="1" md1 class="px-0"  align-self="center">
            <v-btn x-small fab class="success" @click="cardCommentCreate" :disabled="cardCommentModel.description.length == 0"><v-icon>add</v-icon></v-btn>
        </v-col>
        <v-col v-for="cardComment in cardComments"
               :key="cardComment.id"
               cols="12" class="py-1"
        >
            <card-comment-card :cardComment="cardComment"/>
        </v-col>
    </v-row>
</template>

<script>
import CardCommentCard from './CardCommentCard'
import { mapGetters } from 'vuex'
export default {
    name: 'CardCommentForm',
    components: {
        CardCommentCard
    },
    props: ['cardId'],
    data() {
        return {
            create: false,
            cardCommentModel: {
                id: null,
                bot_id: null,
                card_id: null,
                created_at: null,
                status: 1,
                type: 0,
                description: '',
                is_bot: 1,
                user_id: null
            }
        }
    },
    computed: {
        ...mapGetters({
            cardComments: 'cards/cardComments'
        })
    },
    methods: {
        cardCommentCreate() {
            this.$store.dispatch('cards/cardCommentCreate', this.cardCommentModel).then(response => {
                this.cardCommentModel.description = ''
                this.cardCommentModel.id = null
            })
        }
    },
    watch: {
        cardId (value) {
            if (value != null) { this.$store.dispatch('cards/cardCommentAll', this.cardId) }
            this.cardCommentModel.card_id = value
        }
    },
    created() {
        if (this.cardId) {
            this.$store.dispatch('cards/cardCommentAll', this.cardId)
        }
        this.cardCommentModel.bot_id = +this.$route.params['pathMatch']
        this.cardCommentModel.card_id = this.cardId
    }
}
</script>

<style scoped>

</style>
